var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-5"},[_c('hamburger',{attrs:{"path":_vm.$route.path}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w-full md:w-3/5"},[_c('form-user-create')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-secondary p-3 mb-5 rounded-lg flex justify-between items-center"},[_c('h1',{staticClass:"text-lg font-semibold uppercase"},[_vm._v("Create New User")])])
}]

export { render, staticRenderFns }